import { useEffect, useState } from 'react';
import { ModalProps } from './types';
import ReCAPTCHA from 'react-google-recaptcha';
import { Button, CaptchaContent, Content } from './styles';
import ModalCustom from '../ModalCustom';
import { Modal, message } from 'antd';
import { extractFileNameFromUrl, fetchRemoteFile } from '@utils/remoteFile';
import { getEdital } from '@api/EditaisService';

const SITE_KEY = process.env.JORNAL_RECAPTCHA_SITE_KEY as string;

export const EditalDownloadModal = ({
  edital,
  isOpen,
  setEditalInfo,
  onClose,
}: ModalProps) => {
  const [token, setToken] = useState<string | null>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Detalhe via serviço de domínio + instância única (token único de serviço).
    // Sem `/auth/login` nem credenciais hardcoded (ADR-002/ADR-005): a auth de
    // serviço é transparente no client HTTP; a rota é a exclusiva do jornal
    // (`Jornal/Editais/InformacoesAdicionais/{uniqueId}`, ADR-010).
    const fetchEditalInfo = async () => {
      if (!edital?.uniqueId) return;
      try {
        setLoading(true);
        const editalInfo = await getEdital(edital.uniqueId);
        setEditalInfo && setEditalInfo(editalInfo);
      } catch (err) {
        console.error('Erro ao buscar dados:', err);
        message.error('Falha ao obter informações do edital');
      } finally {
        setLoading(false);
      }
    };

    if (isOpen) {
      fetchEditalInfo();
    }
  }, [isOpen, edital, setEditalInfo]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setLoading(true);

      if (edital?.documentosDoEdital) {
        const { blob } = await fetchRemoteFile(edital.documentosDoEdital);
        const fileName = extractFileNameFromUrl(edital.documentosDoEdital);
        const objectUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = objectUrl;
        link.download = fileName;
        link.target = '_blank';
        link.rel = 'noreferrer';
        link.click();

        window.URL.revokeObjectURL(objectUrl);
      } else {
        console.log('Link do documento não encontrado');
        message.error('Falha ao obter o link do documento');
      }
    } catch (err) {
      console.error('Erro ao abrir documento:', err);
      const isUnavailable =
        err instanceof Error && err.message.startsWith('HTTP_');
      const isNetworkIssue =
        err instanceof Error && err.message === 'NETWORK_ERROR';

      if (isNetworkIssue) {
        window.open(
          edital?.documentosDoEdital,
          '_blank',
          'noopener,noreferrer',
        );
        return;
      }

      if (isUnavailable) {
        Modal.warning({
          title: 'Download indisponível',
          content:
            'O arquivo não está disponível no momento. Tente fazer o download mais tarde.',
        });
        return;
      }

      message.error('Arquivo não disponível para download');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalCustom isOpen={isOpen} setModalState={onClose} width="390px">
      <Content>
        <div>
          <h3>Caso queira visualizar o edital, clique abaixo:</h3>
          <CaptchaContent>
            <ReCAPTCHA
              sitekey={SITE_KEY}
              onChange={(key) => setToken(key)}
            />
          </CaptchaContent>
          <Button disabled={!token || loading} onClick={handleSubmit}>
            {loading ? 'Carregando...' : 'Visualizar Edital'}
          </Button>
        </div>
      </Content>
    </ModalCustom>
  );
};
